/* eslint-disable no-promise-executor-return */
/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-shadow */
import { Carousel } from '../Carousel';
import { LiveNewsDrawer } from '../../LiveNewsDrawer';
import { fetchDescription } from './fetchDescription';

export const fetchItems = async (controller: AbortController): Promise<typeof Carousel.SAMPLE_DATA> => {
  if (LiveNewsDrawer.DEBUG) {
    return new Promise<typeof Carousel.SAMPLE_DATA>(resolve => setTimeout(() => resolve(Carousel.SAMPLE_DATA), 2_000));
  }

  const { signal } = controller;

  const page = await fetch('https://olympics.com/en/paris-2024/news', { signal });

  const text = await page.text();

  const pattern = '<script src="/_pr/_next/static/_pr-';

  const start = text.indexOf(pattern) + pattern.length;

  const timestamp = text.slice(start, start + 'YYYY_MM_DDThh_mm_ss.mmmZ'.length);

  const url = `https://olympics.com/_next/data/_pr-${timestamp}/en/paris-2024/news.json?deviceType=desktop&countryCode=US&path=paris-2024&path=news`;

  const json = (await (await fetch(url, { signal })).json()) as {
    pageProps: {
      page: {
        items: {
          name: string;
          data: {
            contentList: {
              imageUrlTemplate: string;
              title: string;
              meta: {
                url: string;
              };
            }[];
          };
        }[];
      };
    };
  };

  return Promise.all(
    json.pageProps.page.items
      .find(({ name }) => name === 'contentListAdvanced')
      ?.data.contentList.map(async ({ imageUrlTemplate, title, meta: { url } }) => ({
        title,
        description: await fetchDescription(url, signal),
        link: url,
        image: imageUrlTemplate.replace('{formatInstructions}', 't_16-9_640'),
      })) ?? [],
  );
};
